import { render } from "./AmendmentView.vue?vue&type=template&id=4fa04e6b&scoped=true"
import script from "./AmendmentView.vue?vue&type=script&lang=js"
export * from "./AmendmentView.vue?vue&type=script&lang=js"

import "./AmendmentView.vue?vue&type=style&index=0&id=4fa04e6b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa04e6b"]])

export default __exports__